
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import TeamMemberCard from '@/components/team/member_card.vue'
import TeamNav from '@/components/team/nav.vue'
import Team from '@/interfaces/team'
import TeamViewMixin from '@/mixins/team_view_mixin'

@Component({
  components: {
    TeamMemberCard,
    TeamNav,
  },
})
export default class TeamOverview extends TeamViewMixin {
  loading = true

  get isTeamLead(): boolean {
    // Find the current user's character, and return if they are the lead
    if (this.team == null) return false
    return this.team.members.find((member) => this.$store.state.user.id === member.character.user_id)?.lead || false
  }

  get url(): string {
    return `${process.env.VUE_APP_URL}/backend/api/team/${this.teamId}/`
  }

  created(): void {
    this.fetchTeam(false)
  }

  async fetchTeam(reload: boolean): Promise<void> {
    // Load the team data from the API
    try {
      const response = await fetch(this.url, { credentials: 'include' })
      if (response.ok) {
        // Parse the JSON into a team and save it
        this.team = (await response.json()) as Team
        this.loading = false
        if (reload) this.$forceUpdate()
        document.title = `${this.team.name} - Savage Aim`
      }
      else {
        super.handleError(response.status)
      }
    }
    catch (e) {
      this.$notify({ text: `Error ${e} when fetching Team.`, type: 'is-danger' })
      Sentry.captureException(e)
    }
  }

  async load(): Promise<void> {
    this.fetchTeam(true)
  }
}
